module.exports = __webpack_public_path__ + "media/images/cplook/social_tab_bg-d9db6bca51ddcf45cb9c4cd848155396.png";